const topLevelRoutes = [
  {
    title: 'Home',
    fullTitle: 'Home',
    icon: 'home',
    path: '/',
    permission: '',
  },
  {
    title: 'Performance',
    fullTitle: 'Performance',
    icon: 'equalizer',
    path: '/performance',
    permission: 'performance',
  },
  {
    title: 'Mail',
    fullTitle: 'Mail',
    icon: 'mail_outline',
    path: '/mail',
    permission: 'mail',
  },
  {
    title: 'ACG',
    fullTitle: 'Automated Campaign Generation',
    icon: 'auto_fix_high_icon',
    path: '/acg',
  },
  {
    title: 'Auth',
    fullTitle: 'Auth',
    icon: 'user',
    path: '/auth',
    hidden: true,
  },
  {
    title: 'Auth',
    fullTitle: 'Auth',
    path: '/unsubscribe',
    icon: 'user',
    hidden: true,
  },
  {
    title: 'Pause',
    fullTitle: 'Pause',
    path: '/pause',
    permission: 'pause.view',
    icon: 'user',
    hidden: true,
  },
  {
    title: '404',
    fullTitle: 'Auth',
    path: '/404',
    icon: 'user',
    hidden: true,
  },
  {
    title: 'Un-Subscription',
    fullTitle: 'Un-Subscription',
    icon: 'unsubscribe',
    path: '/unsubscription',
    permission: 'unsubscription.view',
  },
  {
    title: 'Admin',
    fullTitle: 'Admin Routes',
    icon: 'admin_panel_settings',
    path: '/admin',
    hidden: false,
    permission: 'user.view',
  },
  {
    title: 'Recommendations',
    fullTitle: 'Recommendations',
    icon: 'mail_outline',
    path: '/recommendations',
    permission: 'recommendations.view',
    hidden: false,
  },
  // {
  //   title: 'Phase 1',
  //   fullTitle: 'Phase 1',
  //   icon: 'rule',
  //   path: '/acg',
  //   hidden: false,
  // },
];

export default topLevelRoutes;
